var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"pallet",class:{ palletDoesntFit: _vm.doesNotFit },attrs:{"id":'canvas' + _vm.palletId + _vm.random},on:{"mousemove":_vm.mouseMoved,"mouseout":function($event){_vm.mouseIsOver = -1}}})])}
var staticRenderFns = []

export { render, staticRenderFns }